import { getConfig } from "~/org/twilio/one-support-center/shared/osc-env";

import { WiseOwlIngress, WiseOwlZendeskRealm } from "../types";

const { supportApiEndpoint } = getConfig();

export const buildQueryParams = (queryParams?: Record<string, any>): string => {
  const params: Record<string, any> = {};

  // Filter out undefined or null values
  Object.entries(queryParams ?? {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      params[key] = value;
    }
  });
  const urlParams = new URLSearchParams(params).toString();
  return urlParams ? `?${urlParams}` : "";
};

export const wiseOwlEndpoints = {
  // GATED ENDPOINTS
  getAccessToken: (ingress: WiseOwlIngress): string => `/auth/${ingress}`,
  getChats: "/chats",
  getChatById: (
    chatId: string,
    queryParams?: {
      applicationId?: string;
      interruptedChatId?: string;
    }
  ): string => `/chats/${chatId}${buildQueryParams(queryParams)}`,
  getHome: "/home",
  getHomeInternal: "/chats/home",
  getHomeByApplicationId: (applicationId: string): string =>
    `/home?applicationId=${applicationId}`,
  createChat: "/chats",
  updateChat: (chatId: string): string => `/chats/${chatId}`,
  createFeedback: (chatId: string, messageId: string) =>
    `/chats/${chatId}/messages/${messageId}/feedback`,
  getChatSummaryById: (chatId: string): string => `/chats/${chatId}/summary`,
  // UNGATED ENDPOINTS
  ungatedGetHome: (stargateUngatedUserId: string) =>
    `/ungated/home?stargateUngatedUserId=${stargateUngatedUserId}`,
  ungatedCreateChat: "/ungated/chats",
  ungatedUpdateChat: (chatId: string): string => `/ungated/chats/${chatId}`,
  ungatedCreateFeedback: (chatId: string, messageId: string) =>
    `/ungated/chats/${chatId}/messages/${messageId}/feedback`,
  ungatedGetChatSummaryById: (chatId: string): string =>
    `/ungated/chats/${chatId}/summary`,
};

export const wiseOwlApiDomain = {
  local: "http://localhost:17823/v1",
  dev: "https://comms-gpt.aws-otk-dev-general-use1-001.otk.twilioinfra.com/v1",
  stage:
    "https://comms-gpt.aws-otk-stage-general-use1-001.otk.twilioinfra.com/v1",
  prod: "https://comms-gpt.aws-otk-prod-general-use1-001.otk.twilioinfra.com/v1",
};

export const zendeskAppIds = {
  sandbox: 1019469,
  prod: 1019473,
};

export const wiseOwlZendeskAppHostByRealm = {
  local: `localhost:4567`,
  sandbox: `${zendeskAppIds.sandbox}.apps.zdusercontent.com`,
  prod: `${zendeskAppIds.prod}.apps.zdusercontent.com`,
};

export const wiseOwlZendeskRealmByAppHost = {
  [wiseOwlZendeskAppHostByRealm.local]: WiseOwlZendeskRealm.local,
  [wiseOwlZendeskAppHostByRealm.sandbox]: WiseOwlZendeskRealm.sandbox,
  [wiseOwlZendeskAppHostByRealm.prod]: WiseOwlZendeskRealm.prod,
};

export const wiseOwlApiRootByZendeskHost = {
  // [wiseOwlAppHostByRealm.local]: wiseOwlApiDomain.local,
  [wiseOwlZendeskAppHostByRealm.local]: wiseOwlApiDomain.dev,
  [wiseOwlZendeskAppHostByRealm.sandbox]: wiseOwlApiDomain.stage,
  [wiseOwlZendeskAppHostByRealm.prod]: wiseOwlApiDomain.prod,
};

export const getWiseOwlSalesforceServiceEndpoint = (): string => {
  // TODO: Update with logic to determine WiseOwl Salesforce service endpoint
  return wiseOwlApiDomain.prod;
};

export const getWozdApiServiceEndpoint = () => {
  const serviceEndpoint =
    wiseOwlApiRootByZendeskHost[window.location.host] || wiseOwlApiDomain.prod;

  return serviceEndpoint;
};

export const wiseOwlIngressToServiceEndpointMap: Record<
  WiseOwlIngress,
  string
> = {
  // Runs through Stargate
  [WiseOwlIngress.osc]: `${supportApiEndpoint}/wiseOwl`,
  [WiseOwlIngress.oscUngated]: `${supportApiEndpoint}/wiseOwl`,
  [WiseOwlIngress.console]: `${supportApiEndpoint}/wiseOwl`,
  // Can hit OTK directly
  [WiseOwlIngress.salesforce]: getWiseOwlSalesforceServiceEndpoint(),
  [WiseOwlIngress.zendesk]: getWozdApiServiceEndpoint(),
};
